import React from 'react';
import SkeletonAnimation from '../../../../../../hoc/skeletonAnimation/SkeletonAnimation';

const NavBarSkeleton = ({ skeletonClass }) => {
  return <p className={`w-[155px] mr-[25px]  bg-[#E9E9E9]  h-[19px] ${skeletonClass}`}></p>;
};

export default SkeletonAnimation(NavBarSkeleton);
